module.exports = __webpack_public_path__ + "diilsales-frontend/static/svg/icons.16a3b918749452141a24e1fcf4b66dbe.svg";